import EventListingClass from '../EventListingViewClasses';
import ContentStorage, { ComponentKeys } from '../../../tnew/content/ContentStorage';

function makeResultsDateRangeHeading(formattedDateString) {
  if (formattedDateString === '') {
    return '<h3 class="sr-only">Results</h3>';
  }

  return `<h3 tabindex="0" class="${EventListingClass.RESULTS_HEADING}">${formattedDateString}</h3>`;
}

function makeNoResultsHtml(formattedDateString) {
  const noResultsMessage = ContentStorage.get(ComponentKeys.EVENTS_LISTING_PAGE, 'NoResultsMessage');

  return `
    ${makeResultsDateRangeHeading(formattedDateString)}
    <div class="${EventListingClass.BASE}__no-results-container">
      <div class="${EventListingClass.BASE}__no-results-content">
        ${noResultsMessage}
      </div>
    </div>
  `;
}

function makeBusyIndicatorHtml() {
  const busyIndicatorMessage = ContentStorage.get(ComponentKeys.EVENTS_LISTING_FILTER, 'LoadingMessage');

  return `
    <div class="tn-event-listing-busy-indicator">
      <div class="tn-event-listing-busy-indicator__content">${busyIndicatorMessage}</div>
    </div>
  `;
}

export {
  makeNoResultsHtml,
  makeResultsDateRangeHeading,
  makeBusyIndicatorHtml,
};



// WEBPACK FOOTER //
// ./V7/events/listing/htmlShared/index.js